// This file is automatically generated from Rails routes.
// DO NOT modify it manually.
// To regenerate, run: bin/rake gitlab:js:routes

import { __jsr } from '~/lib/utils/path_helpers/core';
import { hasOrganizationScopedPaths } from '~/lib/utils/path_helpers/utils';


/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/home(.:format)`
 * - Path helper: `home_dashboard_path`
 * - URL helper: `home_dashboard_url`
 * - controller#action: `dashboard#home`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const homeDashboardPath = /*#__PURE__*/ (...args) => {
  const _homeOrganizationDashboardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _homeDashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _homeOrganizationDashboardPath(gon.current_organization.path, ...args);
  }

  return _homeDashboardPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/issues(.:format)`
 * - Path helper: `issues_dashboard_path`
 * - URL helper: `issues_dashboard_url`
 * - controller#action: `dashboard#issues_calendar`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const issuesDashboardPath = /*#__PURE__*/ (...args) => {
  const _issuesOrganizationDashboardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _issuesDashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _issuesOrganizationDashboardPath(gon.current_organization.path, ...args);
  }

  return _issuesDashboardPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/work_items(.:format)`
 * - Path helper: `work_items_dashboard_path`
 * - URL helper: `work_items_dashboard_url`
 * - controller#action: `dashboard#work_items_calendar`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workItemsDashboardPath = /*#__PURE__*/ (...args) => {
  const _workItemsOrganizationDashboardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"work_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _workItemsDashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"work_items"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _workItemsOrganizationDashboardPath(gon.current_organization.path, ...args);
  }

  return _workItemsDashboardPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/merge_requests(.:format)`
 * - Path helper: `merge_requests_dashboard_path`
 * - URL helper: `merge_requests_dashboard_url`
 * - controller#action: `dashboard#merge_requests`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeRequestsDashboardPath = /*#__PURE__*/ (...args) => {
  const _mergeRequestsOrganizationDashboardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _mergeRequestsDashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _mergeRequestsOrganizationDashboardPath(gon.current_organization.path, ...args);
  }

  return _mergeRequestsDashboardPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/activity(.:format)`
 * - Path helper: `activity_dashboard_path`
 * - URL helper: `activity_dashboard_url`
 * - controller#action: `dashboard#activity`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activityDashboardPath = /*#__PURE__*/ (...args) => {
  const _activityOrganizationDashboardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _activityDashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _activityOrganizationDashboardPath(gon.current_organization.path, ...args);
  }

  return _activityDashboardPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/merge_requests/following(.:format)`
 * - Path helper: `merge_requests_following_dashboard_path`
 * - URL helper: `merge_requests_following_dashboard_url`
 * - controller#action: `dashboard#merge_requests`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeRequestsFollowingDashboardPath = /*#__PURE__*/ (...args) => {
  const _mergeRequestsFollowingOrganizationDashboardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"following"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _mergeRequestsFollowingDashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"following"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _mergeRequestsFollowingOrganizationDashboardPath(gon.current_organization.path, ...args);
  }

  return _mergeRequestsFollowingDashboardPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/merge_requests/search(.:format)`
 * - Path helper: `merge_requests_search_dashboard_path`
 * - URL helper: `merge_requests_search_dashboard_url`
 * - controller#action: `dashboard#search_merge_requests`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeRequestsSearchDashboardPath = /*#__PURE__*/ (...args) => {
  const _mergeRequestsSearchOrganizationDashboardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _mergeRequestsSearchDashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _mergeRequestsSearchOrganizationDashboardPath(gon.current_organization.path, ...args);
  }

  return _mergeRequestsSearchDashboardPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/merge_requests/merged(.:format)`
 * - Path helper: `merge_requests_merged_dashboard_path`
 * - URL helper: `merge_requests_merged_dashboard_url`
 * - controller#action: `dashboard#merge_requests`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeRequestsMergedDashboardPath = /*#__PURE__*/ (...args) => {
  const _mergeRequestsMergedOrganizationDashboardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"merged"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _mergeRequestsMergedDashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"merged"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _mergeRequestsMergedOrganizationDashboardPath(gon.current_organization.path, ...args);
  }

  return _mergeRequestsMergedDashboardPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/milestones(.:format)`
 * - Path helper: `dashboard_milestones_path`
 * - URL helper: `dashboard_milestones_url`
 * - controller#action: `dashboard/milestones#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardMilestonesPath = /*#__PURE__*/ (...args) => {
  const _organizationDashboardMilestonesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"milestones"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _dashboardMilestonesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"milestones"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationDashboardMilestonesPath(gon.current_organization.path, ...args);
  }

  return _dashboardMilestonesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/labels(.:format)`
 * - Path helper: `dashboard_labels_path`
 * - URL helper: `dashboard_labels_url`
 * - controller#action: `dashboard/labels#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardLabelsPath = /*#__PURE__*/ (...args) => {
  const _organizationDashboardLabelsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _dashboardLabelsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"labels"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationDashboardLabelsPath(gon.current_organization.path, ...args);
  }

  return _dashboardLabelsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/groups/member(.:format)`
 * - Path helper: `member_dashboard_groups_path`
 * - URL helper: `member_dashboard_groups_url`
 * - controller#action: `dashboard/groups#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const memberDashboardGroupsPath = /*#__PURE__*/ (...args) => {
  const _memberOrganizationDashboardGroupsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"member"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _memberDashboardGroupsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"member"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _memberOrganizationDashboardGroupsPath(gon.current_organization.path, ...args);
  }

  return _memberDashboardGroupsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/groups/inactive(.:format)`
 * - Path helper: `inactive_dashboard_groups_path`
 * - URL helper: `inactive_dashboard_groups_url`
 * - controller#action: `dashboard/groups#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inactiveDashboardGroupsPath = /*#__PURE__*/ (...args) => {
  const _inactiveOrganizationDashboardGroupsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _inactiveDashboardGroupsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _inactiveOrganizationDashboardGroupsPath(gon.current_organization.path, ...args);
  }

  return _inactiveDashboardGroupsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/groups(.:format)`
 * - Path helper: `dashboard_groups_path`
 * - URL helper: `dashboard_groups_url`
 * - controller#action: `dashboard/groups#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardGroupsPath = /*#__PURE__*/ (...args) => {
  const _organizationDashboardGroupsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _dashboardGroupsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationDashboardGroupsPath(gon.current_organization.path, ...args);
  }

  return _dashboardGroupsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/snippets(.:format)`
 * - Path helper: `dashboard_snippets_path`
 * - URL helper: `dashboard_snippets_url`
 * - controller#action: `dashboard/snippets#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardSnippetsPath = /*#__PURE__*/ (...args) => {
  const _organizationDashboardSnippetsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"snippets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _dashboardSnippetsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"snippets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationDashboardSnippetsPath(gon.current_organization.path, ...args);
  }

  return _dashboardSnippetsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/todos(.:format)`
 * - Path helper: `dashboard_todos_path`
 * - URL helper: `dashboard_todos_url`
 * - controller#action: `dashboard/todos#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardTodosPath = /*#__PURE__*/ (...args) => {
  const _organizationDashboardTodosPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"todos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _dashboardTodosPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"todos"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationDashboardTodosPath(gon.current_organization.path, ...args);
  }

  return _dashboardTodosPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/todos/:id(.:format)`
 * - Path helper: `dashboard_todo_path`
 * - URL helper: `dashboard_todo_url`
 * - controller#action: `dashboard/todos#destroy`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardTodoPath = /*#__PURE__*/ (...args) => {
  const _organizationDashboardTodoPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"todos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _dashboardTodoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"todos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationDashboardTodoPath(gon.current_organization.path, ...args);
  }

  return _dashboardTodoPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/projects/contributed(.:format)`
 * - Path helper: `contributed_dashboard_projects_path`
 * - URL helper: `contributed_dashboard_projects_url`
 * - controller#action: `dashboard/projects#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contributedDashboardProjectsPath = /*#__PURE__*/ (...args) => {
  const _contributedOrganizationDashboardProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"contributed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _contributedDashboardProjectsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"contributed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _contributedOrganizationDashboardProjectsPath(gon.current_organization.path, ...args);
  }

  return _contributedDashboardProjectsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/projects/starred(.:format)`
 * - Path helper: `starred_dashboard_projects_path`
 * - URL helper: `starred_dashboard_projects_url`
 * - controller#action: `dashboard/projects#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starredDashboardProjectsPath = /*#__PURE__*/ (...args) => {
  const _starredOrganizationDashboardProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starred"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _starredDashboardProjectsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starred"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _starredOrganizationDashboardProjectsPath(gon.current_organization.path, ...args);
  }

  return _starredDashboardProjectsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/projects/personal(.:format)`
 * - Path helper: `personal_dashboard_projects_path`
 * - URL helper: `personal_dashboard_projects_url`
 * - controller#action: `dashboard/projects#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const personalDashboardProjectsPath = /*#__PURE__*/ (...args) => {
  const _personalOrganizationDashboardProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"personal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _personalDashboardProjectsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"personal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _personalOrganizationDashboardProjectsPath(gon.current_organization.path, ...args);
  }

  return _personalDashboardProjectsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/projects/member(.:format)`
 * - Path helper: `member_dashboard_projects_path`
 * - URL helper: `member_dashboard_projects_url`
 * - controller#action: `dashboard/projects#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const memberDashboardProjectsPath = /*#__PURE__*/ (...args) => {
  const _memberOrganizationDashboardProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"member"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _memberDashboardProjectsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"member"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _memberOrganizationDashboardProjectsPath(gon.current_organization.path, ...args);
  }

  return _memberDashboardProjectsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard/projects/inactive(.:format)`
 * - Path helper: `inactive_dashboard_projects_path`
 * - URL helper: `inactive_dashboard_projects_url`
 * - controller#action: `dashboard/projects#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inactiveDashboardProjectsPath = /*#__PURE__*/ (...args) => {
  const _inactiveOrganizationDashboardProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _inactiveDashboardProjectsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _inactiveOrganizationDashboardProjectsPath(gon.current_organization.path, ...args);
  }

  return _inactiveDashboardProjectsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/dashboard(.:format)`
 * - Path helper: `root_dashboard_path`
 * - URL helper: `root_dashboard_url`
 * - controller#action: `dashboard/projects#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rootDashboardPath = /*#__PURE__*/ (...args) => {
  const _rootOrganizationDashboardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);
  const _rootDashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _rootOrganizationDashboardPath(gon.current_organization.path, ...args);
  }

  return _rootDashboardPath(...args);
};

